import { useDispatch, useSelector } from 'react-redux';
import { Node } from '../../models/models';
import {
    changeNodeStatusStart,
    getNodeStart,
} from '../../store/node/node.action';
import { getProjectStart } from '../../store/project/project.action';
import {
    selectNodeProjectSelected,
    selectProjectSelected,
} from '../../store/project/project.selector';
import { canPutNodeInDoneOrActive } from '../../utils/role/role.utils';

const NodeButtonReopen = ({ node }: { node: Node }) => {
    const nodeProjectSelected = useSelector(selectNodeProjectSelected);
    const projectSelected = useSelector(selectProjectSelected);
    const dispatch = useDispatch();

    const handleReturnClick = () => {
        const status = 'active';

        dispatch(
            changeNodeStatusStart(node.id, status, [], () => {
                dispatch(getNodeStart(node!.id));
                if (nodeProjectSelected) {
                    dispatch(getProjectStart(nodeProjectSelected.id, node.id));
                } else if (projectSelected) {
                    dispatch(getProjectStart(projectSelected.id, null));
                }
            })
        );
    };

    const shouldShowButton = canPutNodeInDoneOrActive(node);

    if (!shouldShowButton) return null;

    return (
        <button
            onClick={handleReturnClick}
            style={{
                borderRadius: '15px',
                background: '#FF9595',
                width: '220px',
                height: '40px',
                flexShrink: 0,
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
            }}
        >
            RIAPRI
        </button>
    );
};

export default NodeButtonReopen;
